import React, { lazy, Suspense } from 'react'
import { FaSpinner } from "react-icons/fa";

const Signinstatus = lazy(() =>
  import("../../components/Signin/Signin")
);

const Signin = () => {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-screen">
          <FaSpinner className="animate-spin text-red-500 text-2xl" />
        </div>
      }
    >
      <Signinstatus />
    </Suspense>
  )
}

export default Signin